export const MOBILE_HEADER_HEIGHT = "90px";
export const DESKTOP_HEADER_HEIGHT = "140px";

export const CLICK_TIMEOUT = 3000;

export const IGNORE_MAX_WIDTH = "[data-ignore-max-width]";
